import ToastStatusGlobal from '@/components/toastStatusGlobal';
import ICONS from '@/shared/entities/constants/icons';
import React, { useState } from 'react';
import { Icon } from 'vkit/lib/components';
import { Tooltip } from 'vkit/lib/context';

interface ButtonClipBoardProps {
  text: string;
  size?: number;
  testId?: string;
}

export const ButtonClipBoard: React.FC<ButtonClipBoardProps> = ({ text, size = 24, testId }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { toast } = ToastStatusGlobal();

  const copyToClipboard = async (text: string) => {
    try {
      const container = document.createElement('div');
      container.innerHTML = text;
      container.style.color = 'initial';
      container.style.position = 'fixed';
      container.style.pointerEvents = 'none';
      container.style.opacity = '0';
      document.body.appendChild(container);
      window.getSelection()?.removeAllRanges();
      const range = document.createRange();
      range.selectNode(container);
      window.getSelection()?.addRange(range);
      document.execCommand('copy'); //NOSONAR
      document.body.removeChild(container);

      setIsCopied(true);

      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao copiar para o clipboard';
      toast('Oops', errorMessage, 'error');
      setIsCopied(false);
      return false;
    }
  };

  return (
    <Tooltip align='center' title={isCopied ? 'Copiado' : 'Copiar'}>
      <button
        data-testid={testId}
        key={`${text}-${isCopied ? 'Copiado' : 'Copiar'}`}
        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        onClick={() => copyToClipboard(text)}>
        <Icon name={isCopied ? ICONS.CHECK : ICONS.COPY} size={size} color='colorDefault' />
      </button>
    </Tooltip>
  );
};
